export type Auth0Config = {
  domain: string;
  clientId: string;
};

export type Auth0ConfigResult =
  | {
      ok: true;
      config: Auth0Config;
    }
  | {
      ok: false;
      missingKeys: string[];
    };

type Auth0EnvKey = 'VITE_AUTH0_DOMAIN' | 'VITE_AUTH0_CLIENT_ID';
type RuntimeEnv = Partial<Record<Auth0EnvKey, string | undefined>>;

const AUTH0_ENV_KEYS = {
  domain: 'VITE_AUTH0_DOMAIN',
  clientId: 'VITE_AUTH0_CLIENT_ID',
} as const;

function hasValue(value: string | undefined): value is string {
  return typeof value === 'string' && value.trim() !== '';
}

export function getAuth0Config(env: RuntimeEnv = import.meta.env): Auth0ConfigResult {
  const missingKeys = Object.values(AUTH0_ENV_KEYS).filter((key) => !hasValue(env[key]));
  if (missingKeys.length > 0) {
    return { ok: false, missingKeys };
  }
  return {
    ok: true,
    config: {
      domain: env.VITE_AUTH0_DOMAIN!,
      clientId: env.VITE_AUTH0_CLIENT_ID!,
    },
  };
}
